var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed, observable, toJS } from 'mobx';
import queryString from 'query-string';
import { Filters } from 'utils';
let QueryStringStore = (_class = class QueryStringStore {
  constructor() {
    this.routingStore = null;
    _initializerDefineProperty(this, "filters", _descriptor, this);
    _initializerDefineProperty(this, "lastFetchedFilters", _descriptor2, this);
  }
  setFilters(group, filters) {
    this.filters[group] = filters;
  }
  saveCurrentFilters() {
    this.lastFetchedFilters = toJS(this.filters);
  }

  //pensar num jeito melhor de fazer isso!
  customChanges(group, filter, option) {
    if (filter === 'ages') {
      if (Array.isArray(option)) {
        if (option.length === 0) {
          return Filters.getDefaultFilter({
            group,
            filter
          });
        }
        if (option.length > 1 && option.some(o => o.value === 'all')) {
          return option.filter(o => o.value !== 'all');
        }
      }
    }
    return option;
  }
  setFilterValue(group, filter, option) {
    this.filters[group][filter] = this.customChanges(group, filter, option);
  }
  getFiltersByGroup(group) {
    if (this.filters[group]) {
      return this.filters[group];
    }
    return {};
  }
  setStore(store) {
    this.routingStore = store;
  }
  hasFilters(group) {
    return this.filters?.[group] !== undefined;
  }
  getLastFetchedFilters(group) {
    return this.lastFetchedFilters[group] || this.filters[group];
  }
  get parsed() {
    if (this.routingStore?.location) return queryString.parse(this.routingStore.location.search);
    return {};
  }
  get stringified() {
    return queryString.stringify(this.parsed);
  }
  evaluate(string, regexp) {
    if (regexp instanceof RegExp) {
      return !regexp.test(string);
    } else {
      return string.toLowerCase() !== regexp.toLowerCase();
    }
  }
  cleanByTerm(regexp, object) {
    return Object.entries(object).map(a => a[1] && this.evaluate(`${a[1]}`, regexp) && {
      [a[0]]: a[1]
    }).filter(Boolean).reduce((acc, v) => Object.assign(acc, v), {});
  }
  merge(defaults) {
    return {
      ...defaults,
      ...this.parsed
    };
  }
  parse({
    filter,
    defaults = {}
  } = {}) {
    if (!filter || !(filter instanceof RegExp) && typeof filter !== 'string') return this.merge(defaults);
    return this.cleanByTerm(filter, this.merge(defaults));
  }
  stringify({
    filter,
    defaults
  }) {
    if (!filter || !(filter instanceof RegExp) && typeof filter !== 'string') return queryString.stringify(this.merge(defaults));
    return queryString.stringify(this.cleanByTerm(filter, this.merge(defaults)));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "filters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "lastFetchedFilters", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, "setFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveCurrentFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveCurrentFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "customChanges", [action], Object.getOwnPropertyDescriptor(_class.prototype, "customChanges"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setFilterValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setFilterValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getFiltersByGroup", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getFiltersByGroup"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setStore", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setStore"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "hasFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "getLastFetchedFilters", [action], Object.getOwnPropertyDescriptor(_class.prototype, "getLastFetchedFilters"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parsed", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "parsed"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stringified", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "stringified"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "parse", [action], Object.getOwnPropertyDescriptor(_class.prototype, "parse"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "stringify", [action], Object.getOwnPropertyDescriptor(_class.prototype, "stringify"), _class.prototype), _class);
export default new QueryStringStore();